var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_547_629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "#D9D9D9",
    stroke: "#181818"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_547_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0567 9.52757V14.7704H9.27617V9.52757H11.0567ZM10.801 7.49774C10.6304 7.6636 10.4192 7.74661 10.1664 7.74661C9.9137 7.74661 9.70249 7.6636 9.53194 7.49774C9.36141 7.33189 9.27617 7.12664 9.27617 6.88114C9.27617 6.63564 9.36141 6.43039 9.53194 6.26454C9.70249 6.09868 9.9137 6.01566 10.1664 6.01566C10.4192 6.01566 10.6304 6.09868 10.801 6.26454C10.9715 6.43039 11.0567 6.63564 11.0567 6.88114C11.0567 7.12664 10.9715 7.33189 10.801 7.49774ZM10.1664 19.1603C8.91919 19.1603 7.74723 18.9301 6.65045 18.4699C5.55344 18.0095 4.59933 17.3848 3.78801 16.5958C2.97669 15.8067 2.33437 14.8789 1.86104 13.8121C1.38781 12.7455 1.15117 11.6059 1.15117 10.393C1.15117 9.18018 1.38781 8.04055 1.86104 6.97401C2.33437 5.90721 2.97669 4.97935 3.78801 4.19032C4.59933 3.40129 5.55344 2.77658 6.65045 2.31621C7.74723 1.85595 8.91919 1.62578 10.1664 1.62578C11.4137 1.62578 12.5857 1.85595 13.6824 2.31621C14.7795 2.77658 15.7336 3.40129 16.5449 4.19032C17.3562 4.97935 17.9985 5.90721 18.4719 6.97401C18.9451 8.04055 19.1817 9.18018 19.1817 10.393C19.1817 11.6059 18.9451 12.7455 18.4719 13.8121C17.9985 14.8789 17.3562 15.8067 16.5449 16.5958C15.7336 17.3848 14.7795 18.0095 13.6824 18.4699C12.5857 18.9301 11.4137 19.1603 10.1664 19.1603ZM10.1664 17.4294C12.1858 17.4294 13.8967 16.7477 15.2984 15.3845C16.7002 14.0213 17.4012 12.3572 17.4012 10.393C17.4012 8.42887 16.7002 6.7648 15.2984 5.40157C13.8967 4.03835 12.1858 3.35673 10.1664 3.35673C8.14711 3.35673 6.43619 4.03835 5.03447 5.40157C3.63273 6.7648 2.93173 8.42887 2.93173 10.393C2.93173 12.3572 3.63273 14.0213 5.03447 15.3845C6.43619 16.7477 8.14711 17.4294 10.1664 17.4294Z",
    fill: "#1C1B1F",
    stroke: "#181818",
    strokeWidth: 0.025
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ccc85dd2035b229a8cf1d80982998ea9.svg";
export { ForwardRef as ReactComponent };